import { getPermissions } from "../auth/authService";

export const ROLE_ADMIN = "ROLE_Admin";
export const ROLE_USER = "ROLE_User";
export const ROLE_RESOLVER = "ROLE_Resolver";
export const ROLE_MANAGER = "ROLE_Manager";

export const ROLE_LEVEL = {
  [ROLE_ADMIN]: 1,
  [ROLE_MANAGER]: 2,
  [ROLE_RESOLVER]: 3,
  [ROLE_USER]: 4,
};

export const HOME = "Home";
export const DASHBOARD = "Dashboard";
export const TICKETS = "Ticket";

export const TASK = "Task";
export const TASK_MANAGEMENT = "Task Management";
export const TASK_SCHEDULER = "Task Scheduler";

export const CHANGE = "Change";

export const SOLUTIONS = "Solutions";
export const ARTICLE = "Article";
export const SUB_CATEGORY = "Sub Categories";
export const CATEGORY = "Categories";

export const ASSETS = "Assets";
export const ASSET_ITEM = "Asset Item";
export const ASSET_TYPE = "Asset Type";
export const ASSET_CLASS = "Asset Class";

export const CI = "CMDB";

export const REPORTS = "Reports";
export const REPORTS_BUILDER = "Report Builder";
export const REPORTS_SCHEDULER = "Report Scheduler";

export const ADMIN = "Administration";
export const SETTINGS = "Settings";

export const QUEUE = "Queue";

export const ROLE_BASED_ROUTES = {
  [ROLE_ADMIN]: [HOME, DASHBOARD, TICKETS, TASK, CHANGE, QUEUE, SOLUTIONS, CI, ASSETS, REPORTS, ADMIN, SETTINGS],
  [ROLE_USER]: [HOME, DASHBOARD, TICKETS, SOLUTIONS],
  [ROLE_RESOLVER]: [
    HOME,
    DASHBOARD,
    TICKETS,
    TASK,
    CHANGE,
    QUEUE,
    SOLUTIONS,
    CI,
    ASSETS
  ],
  [ROLE_MANAGER]: [
    HOME,
    DASHBOARD,
    TICKETS,
    TASK,
    CHANGE,
    SOLUTIONS,
    CI,
    ASSETS,
    REPORTS,
    ADMIN,
  ],
};

export const COMPONENT_HIERARCHY = {
  [HOME]: [HOME],
  [DASHBOARD]: [DASHBOARD],
  [TICKETS]: [TICKETS],
  [QUEUE]: [QUEUE],
  [TASK]: [TASK_MANAGEMENT, TASK_SCHEDULER],
  [CHANGE]: [CHANGE],
  [SOLUTIONS]: [ARTICLE, SUB_CATEGORY, CATEGORY],
  [CI]: [CI],
  [ASSETS]: [ASSET_TYPE, ASSET_CLASS, ASSET_ITEM],
  [REPORTS]: [REPORTS_BUILDER, REPORTS_SCHEDULER],
  [ADMIN]: [ADMIN],
  [SETTINGS]: [SETTINGS],
};

export const getPermissionsForComponent = (componentName) => {
  const permissions = getPermissions();
  const validComponents = COMPONENT_HIERARCHY[componentName] || [];
  const subComponentsPermissions = {};
  // validComponents.forEach((component) => {
  //   subComponentsPermissions[component] = DEFAULT_PERMISSIONS[component];
  // });
  permissions.forEach((permission) => {
    if (validComponents.includes(permission.screenName)) {
      subComponentsPermissions[permission.screenName] = resolvePermissions(
        subComponentsPermissions[permission.screenName] || {},
        permission
      );
    }
  });
  return subComponentsPermissions;
};

const resolvePermissions = (p1, p2) => {
  //TODO: Need to figure out for canViewMenu
  const result = p1;
  if (!p1.canCreate) {
    result.canCreate = p2.canCreate;
  }
  if (!p1.canUpdate) {
    result.canUpdate = p2.canUpdate;
  }
  if (!p1.canDelete) {
    result.canDelete = p2.canDelete;
  }
  if (!p1.canView) {
    result.canView = p2.canView;
  }
  return result;
};

export const DEFAULT_PERMISSIONS = {
  [HOME]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
  [DASHBOARD]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
  [TICKETS]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
  [TASK_MANAGEMENT]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
  [TASK_SCHEDULER]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
  [ARTICLE]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
  [SUB_CATEGORY]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
  [CATEGORY]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
  [ASSET_ITEM]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
  [ASSET_TYPE]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
  [ASSET_CLASS]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
  // [REPORTS]: {
  //   canViewMenu: true,
  //   canCreate: true,
  //   canUpdate: true,
  //   canDelete: true,
  //   canView: true,
  // },
  [REPORTS_BUILDER]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
  [REPORTS_SCHEDULER]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
  [ADMIN]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
  [SETTINGS]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
  [QUEUE]: {
    canViewMenu: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canView: true,
  },
};

export const isEmpty = (obj) => {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }

  return true;
};
